import { editRoutineActivity } from "../api";

export default function EditRoutineActivity({token, setEditCount, setEditDuration, editCount, editDuration, routineActivityId, setEditRoutineActivity}) {

    return <form className="makeRoutine" onSubmit={(event) => {
        event.preventDefault();
        editRoutineActivity(token, routineActivityId, editCount, editDuration);
        setEditRoutineActivity(false);
    }}>
        <h2>Edit Routine Activity</h2>
        <div className="form-element">
            <label htmlFor="create-count">Count</label>
            <input id="create-count" type="number" value={editCount} required onChange={event => {setEditCount(event.target.value)}}></input>
        </div>
        <div className="form-element">
            <label htmlFor="create-duration">Duration</label>
            <input id="create-duration" type="number" value={editDuration} required onChange={event => {setEditDuration(event.target.value)}}></input>
        </div>
        <button type="submit">Submit</button>
        <button onClick={()=> {setEditRoutineActivity(false)}}>Cancel</button>
    </form>
}